import { __exportAll } from "../_virtual/_rolldown/runtime.js";
//#region src/utils/syncable_menu_model_utils.ts
var syncable_menu_model_utils_exports = /* @__PURE__ */ __exportAll({ displayName: () => displayName });
function displayName(data) {
	const name = `${data.name || data.posName || data._id}`;
	if (data.internalName) return `${name} (${data.internalName})`;
	if (data.posInternalName) return `${name} (${data.posInternalName})`;
	return name;
}
//#endregion
export { displayName, syncable_menu_model_utils_exports };

//# sourceMappingURL=syncable_menu_model_utils.js.map